import {useEffect, useRef, useState} from 'react';
import {useSeoByPage} from '../../../backend-services/CategoryStream/Seo/CategoryHeadSeo';
import {useCategoryId} from '../../../backend-services/CategoryStream/utils';

/*
 * The sponsored banner tracking key is used to track the sponsored banner impression.
 * The event should trigger whenever the banner or category page updates.
 * To ensure it's fired only after the correct content_view event,
 * we await the SEO request before proceeding.
 */
export const useSponsoredBannerTrackingKey = (promotionId?: string) => {
  const timerRef = useRef<NodeJS.Timeout>(undefined);
  const seoRequest = useSeoByPage();
  const categoryId = useCategoryId();
  const [trackPromotionKey, setTrackPromotionKey] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    if (seoRequest.isLoading) {
      return;
    }

    // eslint-disable-next-line local-rules/set-state-in-use-effect
    timerRef.current = setTimeout(() => {
      setTrackPromotionKey(`${promotionId}-${categoryId}`);
    }, 1000);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [promotionId, categoryId, seoRequest.isLoading]);

  return trackPromotionKey;
};
